import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { ExpedienteService } from '../expendiente.services';
import Swal from 'sweetalert2';
import { BehaviorSubject, Observable } from 'rxjs';
// idiomas
import { lang_wizard } from 'app/idiomas/i18n/expedientes35/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_fileman } from 'app/idiomas/i18n/fileMan/filemanager.lang';


import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import * as colabInter from './../expediente.interface';

///IDIOMAS
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import {MatTableDataSource} from '@angular/material/table';
export interface resultado{
  BrokerID: string,
  HierarchicalPath: string,
  IdUser: number,
  Institute: number,
  NameUser: string,
  NeedHelp: number, // 0 no 1 es que sí
  RowID: number,
  SecciónI?: number,
  SecciónII?: number,
  SecciónIII?: number,
  SecciónIV?: number,
  surveyToken: string
}

@Component({
  selector: 'tablacolaboradores',
  templateUrl: './tabla-colaboradores.component.html',
  styleUrls: ['./tabla-colaboradores.component.scss'],
  animations   : fuseAnimations
})
export class TablaColaboradoresComponent implements OnInit {
  dataSource: MatTableDataSource<resultado>;
  @Input('listaArchivosEmpresa') listaArchivosEmpresa: any;
  @Input('statusTable') statusTable: any;
  @Input('puedeBorrar') puedeBorrar: boolean;
  @Input('statusTable') statusArchivos: any;

  private eventsSubscription: any
  private eventsSubscription2: any
  @Input() actualizaArchivos: Observable<any>;
  @Input() actualizaFileslist: Observable<any>;
  @Output() carpetaAbierta: EventEmitter<string> = new EventEmitter();

  nombresColumnas = ['icono','nombre'];
  nombresColumnasArch = ['nombre','opc1','opc2'];
  nombresColumnasheader = ['name','date','act'];
  nombresColumnasCont = ['name','date','act'];
  idiomaActual:string;
  carpetaActual = '';
  carpetanombre='';
  urlServidor:string;
  colaboradoresStatus = false;
  listaArchivos:any;

  idColaborador_temporal:any;
  cero_colaboradores:boolean=false;
  carga_completa:boolean=false;

arrayNumero: backInter.arrayPosiciones[]=[];
centrosTrabajo: backInter.getInfoCentros;
centrosTrabajoArray:any;
centrosTrabajoUsers:any;
productoCertificar: backInter.prodNorma35;
productoCertificar_CT: backInter.prodNorma35;
estadoCT=false;
cargando = true;
nombreColaborador:any;
Resultados:boolean=false;
Cargando:boolean=false;
noInformation:boolean=false;
noDatafound:boolean=true;
bloquearTabla:boolean=false;
  constructor(
    private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private expedienteService: ExpedienteService,
    // NEW PRIVATE
    private colaboradoresService: ColaboradoresEncuestadorService,
    private formBuilder: FormBuilder,
    private activated: ActivatedRoute,


  ) {
    lang_fileman.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
    let url = DATOS_API.url.split(":");
    this.urlServidor = url[1];
  }
  listaArchivosEmpresa_temporal:any;
  ngOnInit() {
    this.statusTable=true;
    this.colaboradoresStatus=true;
    this.eventsSubscription = this.actualizaArchivos.subscribe( (datos) => {
      this.noDatafound=false;
      this.listaArchivosEmpresa = datos;
      if(this.listaArchivosEmpresa.length > 0){
        this.noInformation=false;
        this.listaArchivosEmpresa_temporal=this.listaArchivosEmpresa;
        this.dataSource = new MatTableDataSource(this.listaArchivosEmpresa_temporal); // Filtro
        this.dataSource.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
      }else{
        this.noInformation=true;
        console.log("No tiene información");

      }
    });

    this.eventsSubscription2 = this.actualizaFileslist.subscribe( (datos2) => {
      this.getListaArchivos(datos2,this.carpetanombre);
    });
    this.obtieneCertificarActual();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getListaArchivos(folder:string, name:string, idAyuda?:any){
    if(name){
      let rspSi = 'WIZARD.CARGANDO_FILTROS';
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      Swal.fire({
        title: rspSi,
        showConfirmButton: false,
      });
      Swal.showLoading();

    }
    console.log("Ha entrado a la función");
    this.carga_completa=false;
    this.bloquearTabla=true; // Bloquear la función
    this.expedienteService.getInfoColaboradores(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
    .subscribe( (data:colabInter.getBDCoalbFull) => { // Se manda a llamar este servicio para poder obtener el id del trabajo (ID DE MONGO)
      this.colaboradores_listtmp=data.bdcolaboradores;
      for(let i=0; i < this.colaboradores_listtmp.length; i++){
        if(this.colaboradores_listtmp[i].fullName == name){
          this.colabodador_idtmp=this.colaboradores_listtmp[i];
          this.nombreColaborador=this.colaboradores_listtmp[i].fullName;
        }
      }
      if(this.colabodador_idtmp){
        let dataCol = {
          productoId: this.productoCertificar.idNorma35,
        }
        this.expedienteService.getAyudaColaboradores(dataCol)
        .subscribe( (data:backInter.allColaboradoresAyuda) => {
          this.cero_colaboradores=false;
          this.colaboradoresList=data.resultado;
          if(data.resultado.length>0){

            for(let i=0; i< this.colaboradoresList.length;i++){
              if(this.colaboradoresList[i]._id==this.carpetaActual){
                this.nombreColaborador=this.colaboradoresList[i].fullName;
              }
            }
            // IMPORTANTE!!!!!!!!!!!!!
            this.statusTable=true;
            this.carpetaActual = this.colabodador_idtmp._id; // anteriormente ---> this.carpetaActual = folder
            this.carpetanombre=name; // Anteriormente ---> this.carpetanombre=name;
            this.carpetaAbierta.emit(this.colabodador_idtmp._id); // anteiormente  -->this.carpetaAbierta.emit(folder);
            /* ENVIAR PARAMETROS DEPENDIENTE DEL TIPO DE USUARIO*/

            let datosTabla: any = {
              productoId:this.productoCertificar.idNorma35, colaboradorId:this.colabodador_idtmp._id
            };
            // Función para obtener tabla con archivos
            this.expedienteService.getTableBolacoradores(this.productoCertificar.idNorma35,this.colabodador_idtmp._id)
              .subscribe( (dataArch:colabInter.listaarchivos) => {
                  for(let i=0; i< dataArch.evidencias.length;i++){
                    var currentDateTimeCentralTimeZone = new Date(dataArch.evidencias[i].fechaRegistro.toLocaleString('es-es', { timeZone: 'America/Mexico_City' }));
                    var date = new Date(currentDateTimeCentralTimeZone),
                    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                    day = ("0" + date.getDate()).slice(-2);
                    var dateTmp= date.getFullYear()+'/'+mnth+'/'+day;
                    dataArch.evidencias[i].updatedAt=date.getFullYear()+'/'+mnth+'/'+day;
                    //this.listaArchivos=dataArch;
                  }
                this.carga_completa=true; // PROBLEMA CUANDO TARDA EN CARGAR
                Swal.close();
                this.listaArchivos=dataArch;
                this.statusTable=false;
                //this.estadoCT=false;
            });
          }else{
            this.cero_colaboradores=true;
            // ES La SEGUNDA PARTE BROTHAR
          }
        },error =>{
          console.log("Ocurrio un error en los colaboradores");
          console.log(error);
        });


      }

    },error =>{
      console.log("Erro al mostar la BD de los colaboradores");
      console.log(error);
    });
  }
  colaboradores_listtmp:any;
  colabodador_idtmp:any;


  borraArchivo(idArchivo:string){
    let texto = 'FILEMANAGER.MENSAJES.DELETERLY';
    let rspSi = 'FILEMANAGER.MENSAJES.BOTONES.SI';
    let rspNo = 'FILEMANAGER.MENSAJES.BOTONES.NO';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });
    Swal.fire({
      title: texto,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: rspSi,
      cancelButtonText: rspNo
    }).then((result) => {
      if (result.value) {
        this.colaboradoresService.getColaboradoresFast(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
          .subscribe( (getFast: colabInter.getBDFast) => {
            this.info=this.colaboradoresService.getinfo();
            if(this.info.level==6){
              let datos = {productoId: this.info.productoId, evidenciaId:idArchivo};
              this.expedienteService.borrarArchivo_CT(datos,this.info.empresaPadre).subscribe( (data:any) => {
                if(data.message == "Successfully deleted"){
                  this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEOK',1);
                  this.getListaArchivos(this.carpetaActual,this.carpetanombre);
                }
              });

            }else{
              let datos = {productoId: this.productoCertificar.idNorma35, evidenciaId:idArchivo};
              this.expedienteService.borrarArchivo(datos).subscribe( (data:any) => {
                if(data.message == "Successfully deleted"){
                  this.mensajeSwal('FILEMANAGER.MENSAJES.DELETEOK',1);
                  this.getListaArchivos(this.carpetaActual,this.carpetanombre);
                }
              });
            }
        });
      }
    });
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let texto = '';
    this.translateSrv.get(mensaje).subscribe((res: string) => { texto = res; });
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: texto,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  // NEW SERVICES
  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.productoCertificar_CT = producto;
              throw BreakException;
            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      this.obtenerCentros();
      this.getAllColaboradoresAyuda();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }


  obtenerCentros(){
    this.expedienteService.getInfoCentros(this.productoCertificar.fechaNorma35).subscribe( (resu:backInter.getInfoCentros) => {
      this.centrosTrabajoArray=resu.centros;
      this.centrosTrabajo = resu;
      this.centrosTrabajoUsers=this.centrosTrabajoArray.user;
      this.cargando = false;
      this.estadoCT=true;
    });
  }

  colaboradoresList:any;
  info:any;
  arrayPos:any;
  arrayAux:any [];

  listaArchivosEmpresaTmp: any [] = [];
  NoshowTable:boolean=false;
  getAllColaboradoresAyuda(){
    //console.log("Colaboradores ayuda");
    //console.log(this.listaArchivosEmpresa);
    this.carga_completa=false;
    let dataCol = {
      productoId: this.productoCertificar.idNorma35,
    }
    this.cero_colaboradores=false;
    this.Resultados=true;
    this.carga_completa=true
    this.Cargando=true;
    /*if(this.noDatafound){
      console.log("No tiene información desd eel inicio");
      this.NoshowTable=true;
    }else{

      console.log("Tienes información");
    }*/
  }

  btn_inicio(){
    this.carga_completa=false;
    let rspSi = 'WIZARD.CARGANDO_FILTROS';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    Swal.fire({
      title: rspSi,
      showConfirmButton: false,
    });
    Swal.showLoading();
    let dataCol = {
      productoId: this.productoCertificar.idNorma35,
    }
    this.expedienteService.getAyudaColaboradores(dataCol)
    .subscribe( (data:backInter.allColaboradoresAyuda) => {
      if(data.resultado.length>0){
        this.cero_colaboradores=false;
        this.listaArchivosEmpresa=data.resultado;
        if(localStorage.getItem('Leveuser') == '6'){
          this.filtroCT(localStorage.getItem('Idct_BD'));
        }
        for(let i=0; i<this.listaArchivosEmpresa.length;i++ ){
          if(this.listaArchivosEmpresa[i].NeedHelp == 1){
            this.listaArchivosEmpresaTmp.push(this.listaArchivosEmpresa[i]);
          }
        }
        this.carga_completa=true; // PROBLEMA CUANDO TARDA EN CARGAR
        this.listaArchivosEmpresa=this.listaArchivosEmpresaTmp;
        this.dataSource = new MatTableDataSource(this.listaArchivosEmpresa); // Filtro
        this.dataSource.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.listaArchivosEmpresaTmp=[];
        this.statusTable=true;
        this.bloquearTabla=false;
        this.carpetaActual='';
        Swal.close();
      }else{
        this.cero_colaboradores=true;
        console.log("aún no tienes resultados");
      }
    });
  }
  listaArchivosEmpresaTmp_hijos: any [] = [];
  filtroCT(IdCt){
    this.carga_completa=false;
    console.log("Ha entrado filtro");
    let dataCol = {
      productoId: this.productoCertificar.idNorma35,
    }
    this.expedienteService.getAyudaColaboradores(dataCol)
    .subscribe( (data:backInter.allColaboradoresAyuda) => {
      if(data.resultado.length>0){
        this.cero_colaboradores=false;
        this.listaArchivosEmpresa=data.resultado;
        for(let i=0; i<this.listaArchivosEmpresa.length;i++ ){
          if(this.listaArchivosEmpresa[i].Institute == IdCt && this.listaArchivosEmpresa[i].NeedHelp == 1){
            this.listaArchivosEmpresaTmp_hijos.push(this.listaArchivosEmpresa[i]);
          }
        }
        this.listaArchivosEmpresa=this.listaArchivosEmpresaTmp_hijos;
        this.dataSource = new MatTableDataSource(this.listaArchivosEmpresa); // Filtro
        this.dataSource.filterPredicate = (data, filterValue: string)  => {
          const accumulator = (currentTerm, key) => {
            return key === 'doctores' ? currentTerm : currentTerm + data[key];
          };
          const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
          // Transform the filterValue by converting it to lowercase and removing whitespace.
          const transformedFilter = filterValue.trim().toLowerCase();
          return dataStr.indexOf(transformedFilter) !== -1;
        };
        this.carga_completa=true; // PROBLEMA CUANDO TARDA EN CARGAR
        this.listaArchivosEmpresaTmp_hijos=[];
        Swal.close();
      }else{
        this.cero_colaboradores=true;
        console.log("aún no tienes resultados");
      }
    });
  }
}
